/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Check_EmailInputs */



/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Login_Check_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_check_email = /** @type {((inputs?: Login_Check_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Check_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez votre email")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revise su correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Verifique seu e-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla la tua email")
	return /** @type {LocalizedString} */ ("Check your email")
});